import main from './main.vue'
const commonHeaderV3 = {
  install:function(Vue) {
    Vue.component(main.name, main)
  }
}
// 导出该组件
export default commonHeaderV3